export default {
  common: {
    no: "No",
    actions: "Actions",
    active: "Active",
    add_success: "Added Success",
    add: "Add new",
    admin_panel: "Admin Panel",
    login: "Login",
    register: "Register",
    registerUse: "Register by",
    all: "All",
    alreadyExist: "The value is already exists",
    apply: "Apply",
    back: "Back",
    cancel: "Cancel",
    close: "Close",
    complete: "Complete",
    configuration: "Configuration",
    continue: "Continue",
    create_at: "Create At",
    create_by: "Create By",
    create: "Create",
    date_filter: "Select date range",
    dateFormat: "MM-DD-YYYY",
    dateTimeFormat: "MM-DD-YYYY HH:mm",
    deleteConfirm: "Do you want to delete?",
    delete_success: "Deleted Success",
    deleteError: "Deleted unsuccess",
    delete: "Delete",
    deleted: "Delete {msg} success!",
    description: "Description",
    design: "Design",
    detail: "Detail",
    disabled: "Disabled",
    edit: "Edit",
    enabled: "Enabled",
    history: "History",
    index: "Index",
    input_filter: "Input text",
    invalidFormat: "Invalid Format",
    preview: "Preview",
    process: "Process",
    profile: "Profile",
    rows_per_page_text: "rows per page: ",
    save: "Save",
    saveLink: "Save post",
    savedLink: "Saved link",
    unSaveLink: "Unsaved",
    search: "Search",
    select_filter: "Select an option",
    select_one: "Please select at least one item.",
    select: "Select",
    status: "Status",
    submit: "Submit",
    sure: "Are you sure?",
    type: "Type",
    save_success: "Saved success",
    update_success: "Updated Success",
    validate_fail: "Validate failed",
    validate_form_fail: "Validate failed!",
    use: "This item is being used. Please create a new item.",
    zoomin: "Zoom in",
    zoomout: "Zoom out",
    zoomfit: "Zoom fit",
    clear: "Clear",
    reorder: "Re Order",
    notmatch: "Not Match",
    year: "Year",
    permissionNotAllow: "Permision not allow",
    loadmore: "Load more",
    exportReport: "Export report",
    sendEmail: "Send Email",
    sendCode: "Send code",
    code: "Verify code",
    missFile: "Can't find file",
    uploadSuccess: "Upload success",
    uploadFailed: "Upload failed",
    chargeMoney: "Charge Money",
    offline: "Your computer is offline, please check your connection",
    change: "Change",
    notfound: "Not found",
    addnew: "Add new",
    copy: "Copy",
    addReport: "Add report",
    createForm: "Create form",
    licenseEndDate: "Ngày hết hạn"
  },
  form: {
    title: "Form management",
    add_edit: "Add/Edit form",
    code: "Form code",
    name: "Form name"
  },
  footer: {
    title: "YoClass",
    copy: "Copyright 2019"
  },
  header: {
    title: "ACTIP"
  },
  menu: {
    list: "Menu List"
  },
  route: {
    dashboard: "Dashboard"
  },
  search: {
    title: "Full text search",
    crawler: "Crawle data",
    input: "search input",
    schema: "Schema",
    tablename: "Table name",
    columnname: "Column name",
    view_column: "View columns",
    index_table: "Index table",
    index_all: "Index tables",
    upload_index: "Index file",
    index_title: "Index data"
  },
  setting: {
    title: "Settings",
    menu_list: "Menu List"
  },
  task: {
    titleCompleted: "Completed task",
    title: "Task management",
    taskname: "Task name",
    assignnee: "Assignnee",
    owner: "Owner",
    duedate: "Due date",
    detail: "Task detail",
    start: "Start process",
    form: "Form input",
    endtime: "End time",
    duration: "Duration",
    worktime: "Worktime",
    durationFormat: "dd day hh H: mm M : ss S",
    noformToView: "The task form hasn't been configured"
  },
  timeformat: {
    datetime_example: "Datetime example",
    datetime_format: "Datetime Format",
    time_example: "Time example",
    time_format: "Time Format",
    title: "Date & Time Format",
  },
  workflow: {
    title: "Process management",
    code: "Process code",
    name: "Process name",
    add_edit: "Create/Edit process definition",
    edit_property: "Edit property",
    hide_property: "Hide property",
    show_property: "Show property"
  },
  department: {
    code: "Department code",
    name: "Department name",
    address: "Address",
    phone: "Phone",
    email: "Email",
    parent: "Parent",
    info: "Department Info",
  },
  user: {
    title: "User",
    profile: "Profile",
    login: "Login",
    forgotPassword: "Forgot Password",
    username: "User Name",
    phone: "Phone number",
    fullName: "Full Name",
    oldPassword: "Old password",
    password: "Password",
    newPassword: "New Password",
    retypePassword: "Retype Password",
    retypeNewPassword: "Retype new password",
    email: "Email",
    birthday: "Birthday",
    role: "Role",
    teacher: "Teacher",
    pupil: "Pupil",
    verify: "Verify",
    verifyCode: "Verify code",
    verifyTitle: "Hãy nhập mã xác thực đã được gửi đến emai/số điện thoại của bạn!",
    registerSuccess: "Register Success",
    passwordNotMatch: "Password Not Matching",
    passwordEmpty: "Password is Empty",
    duplicate: "User is registered",
    emailDuplicate: "Email is registered",
    emailExist: "Email is already existed",
    usernameExist: "Email is already existed",
    contact: "Contact",
    status: "Status",
    changePassword: "Đổi mật khẩu",
    passwordNotCorrect: "Password is not correct",
    yolearn: "Yolearn",
    zalo: "Zalo",
    reset: "Reset",
    numberClass: "Số lớp tối đa"
  },
  role: {
    title: "role",
    roleName: "Role name",
    description: "Role description",
    active: "Active",
    permission: "Permission",
    menu: "Menu",
    checkAll: "Check all",
    accessLevel: "Access level",
    none: "None",
    read: "Read",
    write: "Write",
    read_write: "Read & Write"
  },
  teacher: {
    name: "Teacher name",
    workingAt: "Working at",
    experience: "Experience",
    objective: "Objective",
    avatar: "Avatar",
    cv: "CV"
  },
  class: {
    title: "Class",
    welcome: "Welcome to Yoclass!<br> Please create your class now!",
    empty_class_admin_teacher: "Bạn chưa có lớp học nào.<br> Tạo lớp học để sử dụng tính năng quản lý lớp học của Yoclass ngay bây giờ!",
    empty_class_student: "Tham gia lớp học Yoclass để Giáo viên thấy được sự tiến bộ của bạn ngay bây giờ!",
    empty: "You haven't joined any class yet",
    joinClass: "Join Class",
    joined: "You joined",
    createClass: "Create new Class",
    classNotFound: "Class code not found",
    className: "Class name",
    classCode: "Class code",
    subject: "Subject",
    teacherName: "Teacher",
    schoolName: "School",
    chapter: "Chapter",
    grade: "Grade",
    description: "Description",
    discipline: "Discipline",
    classInfo: "Class Info",
    student: "Student",
    all: "All",
    lecture: "Lecture",
    exercise: "Exercises",
    reference: "References",
    members: "Members",
    event: "Events",
    member: "Member",
    joinSuccess: "Join Success and please wait to approve",
    sendExercise: "Send",
    sendToStudent: "Send",
    send: "Send",
    post: "Post",
    createQuiz: "Create quiz exercise",
    createEssay: "Create essay exercise",
    report: "Report",
    classBlock: "Class block",
    library: "Library",
  },
  category: {
    name: "Category name",
    code: "Category code",
    description: "Description",
    categoryManagement: "Category Management",
    categoryType: "Category Type",
    createCategory: "Create Category",
    createCategoryType: "Cate Category Type",
    subject: "Subject",
    subjectCode: "Subject Code",
    subjectName: "Subject Name",
    createSubject: "Create Subject",
    degree: "Degree",
    degreeCode: "Degree Code",
    degreeName: "Degree Name",
    createDegree: "Create Degree",
    discipline: "Discipline",
    disciplineCode: "Discipline Code",
    disciplineName: "Discipline Name",
    createDiscipline: "Create Discipline",
    duplicateCode: "Duplicate code of category",
    duplicateName: "Duplicate name of category",
    similarTest: "Similar Test Category",
    similarTestCode: "Similar Test Code",
    similarTestName: "Similar Test Name",
    allItem: "",
  },
  status: {
    active: "Active",
    notActive: "Not Active"
  },
  feed: {
    pleasePost: "Please share your idea",
    pleaseComment: "Please comment",
    tags: "Tags",
    like: "Like",
    comment: "Comment",
    image_video: "Image/Video/Document",
    emotion: "Emotion",
    done: "Done",
    view: "View",
    copyLink: "Copy link"
  },
  exercise: {
    essayQuestion: "Essay exercise",
    quizQuestion: "Quiz exercise",
    name: "Name",
    subject: "Subject",
    dueDate: "Due date",
    effectiveDate: "Effective date",
    markScale: "Mark Scale",
    content: "Content",
    fromLocal: "From My computer",
    fromLibrary: "From Library",
    fromWarehouse: "From warehouse",
    questionBank: "Question Bank",
    numberOfQuiz: "Number of quiz",
    answer: "Answer",
    hardLevel: "Hard level",
    questionTime: "Question time",
    answerFile: "Answer file",
    doExercise: "Do exercise",
    title: "Exercise",
    result: "Result",
    report: "Report",
    mark: "Mark",
    comment: "Comment",
    teacherComment: "Promote",
    teacherCommentImprove: "Improve",
    returnExercise: "Return Exercise",
    student: "Student",
    endTime: "Send time",
    doing: "Doing",
    sent: "Sent",
    marked: "Marked",
    returned: "Returned",
    uploadResultFile: "Upload result file",
    receivers: "Students",
    questionInStore: "USE QUESTION FROM YOLEARN",
    term: "Term",
    examType: "Exam type",
    chapter: "Chapter",
    lesson: "Lesson",
    viewAnswer: "View Answer"
  },
  notification: {
    title: "Notify",
    notifyEmpty: "You don't have any notification",
    loadAll: "Load all"
  },
  userlog: {
    title: "User Log",
    userName: "User",
    feature: "Feature",
    description: "Description",
    createFrom: "Create From",
    createTo: "Create To"
  },
  account: {
    approve: "Approve",
    approveYocoin: "Approve Yoccoin",
    manage: "Yocoin management",
    userName: "Payer",
    addYocoin: "Charge YoCoin",
    amount: "Amount",
    amountYocoin: "Yocoin Amount",
    yocoin: "Yocoin",
    pay: "Pay"
  },
  procedure: {
    title: "Procedure management",
    createForm: "Create/Edit Procedure",
    name: "Procedure name",
    code: "Procedure code",
    area: "Area",
    config: "Config",
    fee: "Fees",
    documentOfFile: "Document Of File",
    documentOfTask: "Document of task",
    documentTemplate: "Document tempalte",
    documentCode: "Document code",
    documentName: "Document name",
    taskName: "Task name",
    mailTemplate: "Email template",
    feeName: "Fee name",
    feeType: "Fee type",
    unit: "Unit",
    price: "Price",
    nofee: "No fee",
    start: "Create File",
    officialFee: "Official",
    attorneyFee: "Attorney",
  },
  $vuetify: {
    dataIterator: {
      rowsPerPageText: "Items per page:",
      rowsPerPageAll: "All",
      pageText: "{0}-{1} of {2}",
      noResultsText: "No matching records found",
      nextPage: "Next page",
      prevPage: "Previous page"
    },
    dataTable: {
      rowsPerPageText: "Rows per page:"
    },
    noDataText: "No data"
  },
  customer: {
    customerGeneral: "Thông tin chung về khách hàng",
    customerForm: "Danh sách khách hàng",
    customerName: "Tên khách hàng",
    email: "Email",
    contact: "Đầu mối liên hệ",
    agentAddress: "Địa chỉ khách hàng",
    code: "Mã khách hàng",
    phone: "Số điện thoại",
    customerType: "Loại",
    language: "Ngôn ngữ",
    action: "Thao tác",
    createCustomer: "Tạo mới khách hàng",
    country: "Nước",
    manageId: "Người quản lý",
    discount: "Chiết khấu",

  },
  customerRepresent: {
    formName: "Đơn vị đại diện",
    representFullName: "Tên người đại diện",
    representEmail: "Email người đại diện",
    phone: "Số điện thoại",
    roleName: "Chức vụ",
  },
  customerDocument: {
    formName: "Tài liệu",
    createformName: "Tạo mới tài liệu",
    documentCode: "Loại tài liệu",
    documentName: "Tên tài liệu",
  },
  request: {
    subject: "Tiêu đề",
    content: "Nội dung",
    manageId: "Người quản lý",
    customerId: "Khách hàng",
    customerRef: "Số tham chiếu",
    fromEmail: "Email khách hàng",
    deleted: "Deleted",
    waiting: "Waiting",
    assigned: "Assigned",
    filed: "Filed",
    done: "Done"
  },
  files: {
    titleCreate: "Tạo hồ sơ",
    viewFile: "Xem hồ sơ",
    procedureId: "Thủ tục",
    customerId: "Mã khách hàng",
    manageId: "Người phụ trách",
    customerRef: "Mã tham chiếu",
    title: "Danh sách hồ sơ",
    add: "Thêm mới",
    edit: "Cập nhật",
    appliantForm: "Danh sách chủ đơn",
    applicant: "Chủ đơn",
    applicantAddress: "Địa chỉ",
    clazzForm: "Danh sách class",
    clazz: "Clazz",
    listOfGoodEn: "Danh sách sản phẩm (EN)",
    listOfGoodVi: "Danh sách sản phẩm (VI)",
    numberOfGood: "Số lượng sản phẩm",
    validate_fail_listOfGood: "Số lượng sản phẩm tiếng Anh khác số lượng sản phâm tiếng Việt",
    fileattachsForm: "Danh sách file đính kèm",
    attachTypeId: "Loại đính kèm",
    attachCode: "Mã file",
    attachName: "Tên file",
    attachId: "File đính kèm",
    registerCountryId: "Nước đăng ký",
    ourFile: "Mã hồ sơ",
    agentAddress: "Địa chỉ",
    contact: "Đầu mối liên hệ",
    email: "Email",
    checkId: "Người kiểm tra",
    trademark: "Trademark",
    sampleOfTrademark: "sampleOfTrademark",
    color: "Màu sắc",
    yourFile: "yourFile",

    note: "Ghi chú",
    searchPrefilling: "searchPrefilling",
    disclaimer: "disclaimer",
    priorityDate: "Ngày ưu tiên",
    priorityNo: "Số ưu tiên",
    countryId: "Nước ưu tiên",
    attach: "File đính kèm",
    poaAttach: "Tài liệu POA",
    poaNumber: "Số đơn",
    feeCalculate: "Charge",
    document: "Compose document",
    composeEmail: "Compose Email",
    numberOfObject: "Number of object",
    total: "Total"
  },
  fee: {
    description: "Description",
    amount: "Amount",
    official: "Official",
    attorney: "Attorney",
    subtotal: "Subtotal",
    discount: "Discount",
    tax: "tax",
    bankCharge: "Intermediate bank charge",
    total: "Total"
  },
  pond: {
    
  }
};
